import { createContext, useContext, type ReactNode } from 'react';
import type { TenantsApi } from './tenants.js';

const Context = createContext<TenantsApi | null>(null);

export function TenantsApiProvider({ api, children }: { api: TenantsApi; children: ReactNode }) {
  return <Context.Provider value={api}>{children}</Context.Provider>;
}

export function useTenantsApi(): TenantsApi {
  const api = useContext(Context);
  if (api === null) throw new Error('useTenantsApi вызван вне TenantsApiProvider');
  return api;
}
